import { useTranslation } from 'next-i18next';
import Icon from '@/components/common/iconedLinks/Icon';
import { NS } from '@/constants';
import { URLS } from '@/constants/urls';
import { useAppDispatch } from '@/redux';
import { openBetaModal } from '@/redux/slices/assistant.slice';
import styles from './virtual-assistant-beta.module.scss';

export const VirtualAssistantBeta = () => {
	const { t } = useTranslation([NS.COMMON, NS.ALTER]);
	const dispatch = useAppDispatch();

	return (
		<div className={styles.beta}>
			{t('common:assistant.beta.title')}
			<Icon
				src={URLS.INFORMATION_GREY}
				onClick={(e) => {
					e.stopPropagation();
					dispatch(openBetaModal());
				}}
				alt={t('alter:informations')}
			/>
		</div>
	);
};
